import request from "../../../helpers/request";

interface TRequestRptPtosPanorama {
  idLoja: string;
  reportType: string;
}

export const getRptPtosPanorama = async ({
  idLoja,
  reportType,
}: TRequestRptPtosPanorama) => {
  if (!idLoja) return null;
  const url = `${process.env.REACT_APP_API}/Relatorio/RptPtosPanorama/${idLoja}?reportType=${reportType}`;
  const result = await request({ url, responseType: "blob" });
  return result;
};
